



	import {Component, Mixins} from "vue-property-decorator";

	@Component({
  components: {}
})
export default class ReportView extends Mixins() {}
